<script setup lang="ts">
definePage({
  meta: {
    requiresAuth: true
  },
})
</script>

<template>
  <div>
    <div class="mt-4">
      <span class="text-h4">Version 1.2.11</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>Échantillons sur les semis</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.2.0</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>PRSM: Début du portail Prisme.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.1.2</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Nouveau: on peux désormais imprimer le rapport semaine.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.1.1</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Nouveau: on peux désormais déplacer les buckets de date dans rapport semaine.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.1.0</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>Nouveau: système d'alertes SMS.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.5</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Nouveau: rapport producteurs.</li>
        <li>VGCO: On peux désormais alloué les buckets par palette.</li>
        <li>VGCO: Le bucket ouvre directement dans le rapport semaine.</li>
        <li>VGCO: Total par jour dans le rapport semaine.</li>
        <li>VGCO: On peux désormais sélectionner dans le rapport semaine pour avoir la somme.</li>
        <li>VGCO: Dans le rapport les boutons changent de couleur selon la date de vérification.</li>
        <li>VGCO: Si un bucket tombe le dimanche dans une commande, mettre le samedi la veille à la place.</li>
        <li>VGCO: Dans le graphique buckets / semaine, peux maintenant voir plus d'une semaine à la fois.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.4</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: On peux maintenant voir les rapport semaines et récoltes des autres producteurs.</li>
        <li>VGCO: Rapport de la semaine: les premières lignes restent visibles.</li>
        <li>VGCO: Refonte du rapport semaine, va chercher jusqu'à 3 semaines dans le passé pour calculer le montant rapporté.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.3</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Utilise la date de coupe lors de l'attribution de buckets dans une commande.</li>
        <li>VGCO: Retrait des sous-buckets dans le rapport semaine.</li>
        <li>VGCO: Réglage d'un bug d'affichage qui affichait plusieurs cultures en même temps.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.2</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Rajout de la possibilité de modifier la date d'un bucket dans une commande.</li>
        <li>Réglages sur la page météo principale.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.1</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>VGCO: Nouveau: Rapport des récoltes quotidiennes.</li>
      </ul>
    </div>

    <div class="mt-4">
      <span class="text-h4">Version 1.0.0</span>
      <ul style="list-style-type: disc; margin-left: 30px;">
        <li>Première version en production.</li>
      </ul>
    </div>
  </div>

  <div class="wrapper">
    <v-icon icon="custom:wizard-onion" size="3.5em" color="secondary" class="mb-4"  />
  </div>
</template>

<style scoped>
.wrapper {
  position: relative;
  top: calc(50vh - 330px);
  text-align: center;
}
</style>
